export default __webpack_public_path__ + "static/media/bendik.517ff6ec.jpg";